import { Component } from '@angular/core';

@Component({
  selector: 'ui-checkbox-label',
  templateUrl: './checkbox-label.html',
})
export class CheckboxLabel {}
